
import { renderRule as imagePanel } from './imagePanel/render';
export const items = [
  imagePanel,
]